var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column justify-center align-center full-height"
    },
    [
      _c(
        "div",
        { staticClass: "d-flex flex-column align-center message404" },
        [
          _c("h1", [_vm._v("OH NO! 404")]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { large: "", outlined: "", color: "#34417c" },
              on: { click: _vm.goHome }
            },
            [_vm._v("\n    Go to home\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("v-img", {
            attrs: {
              contain: "",
              height: "auto",
              "max-width": "450",
              src: require("@/assets/img/connectionFail.png")
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("b", [_vm._v("THE LINK YOU FOLLOWED IS PROBABLY")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("b", [_vm._v("BROKEN OR THE PAGE HAS BEEN REMOVED.")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d989eb38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d989eb38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404.vue
// module id = 296
// module chunks = 1